(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[64037],{

/***/ 61570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var ClutchWidget = function(param) {
    var _isLight = param.isLight, isLight = _isLight === void 0 ? false : _isLight;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isScriptLoaded = ref[0], setIsScriptLoaded = ref[1];
    var widgetRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var existingScript = document.querySelector('script[src="https://widget.clutch.co/static/js/widget.js"]');
        if (existingScript) return;
        var script = document.createElement("script");
        script.src = "https://widget.clutch.co/static/js/widget.js";
        script.async = true;
        script.onload = function() {
            setIsScriptLoaded(true);
        };
        document.body.appendChild(script);
        return function() {
            document.body.removeChild(script);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isScriptLoaded || !widgetRef.current) return;
        if (isLight) {
            widgetRef.current.removeAttribute("data-darkbg");
        } else {
            widgetRef.current.setAttribute("data-darkbg", "darkbg");
        }
        if (window.CLUTCHCO) {
            window.CLUTCHCO.Init();
        }
    }, [
        isLight,
        isScriptLoaded
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: widgetRef,
        className: "clutch-widget",
        "data-url": "https://widget.clutch.co",
        "data-widget-type": "1",
        "data-height": "40",
        "data-nofollow": "true",
        "data-expandifr": "true",
        "data-clutchcompany-id": "381822",
        "data-darkbg": isLight ? "" : "darkbg"
    }, isLight ? "clutch-light" : "clutch-dark");
};
/* harmony default export */ __webpack_exports__["Z"] = (ClutchWidget);


/***/ }),

/***/ 45783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ getContentfulImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);


var getContentfulImage = function(_param) {
    var src = _param.src, width = _param.width, quality = _param.quality, progressive = _param.progressive, format = _param.format, transparent = _param.transparent, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "quality",
        "progressive",
        "format",
        "transparent"
    ]);
    try {
        var url = new URL(src);
        var fm = format || (transparent ? "webp" : "jpg");
        if (!format && src.includes(".svg")) {
            fm = null;
        }
        if (fm === "jpg") {
            fm = "webp";
        }
        fm && url.searchParams.set("fm", fm);
        width && url.searchParams.set("w", width);
        quality && url.searchParams.set("q", quality);
        Object.entries(params).forEach(function(param) {
            var _$_param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _$_param[0], value = _$_param[1];
            return key && value && url.searchParams.set(key, value);
        });
        return url.href;
    } catch (e) {
        return src;
    }
};


/***/ }),

/***/ 64037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footer_DefaultFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./UI/components/ClutchWidget/index.jsx
var ClutchWidget = __webpack_require__(61570);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/sections/Footer/DefaultFooter/FooterBody/styles.module.scss
var styles_module = __webpack_require__(60547);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./UI/sections/Footer/DefaultFooter/utils/data.js

var mainContent = [
    {
        title: "Expertise",
        type: "expertise",
        links: [
            {
                subtitle: "Chat development",
                path: constants/* ROUTES.customChatApp.path */.y2.customChatApp.path,
                type: "navigation"
            },
            {
                subtitle: "Mobile development",
                path: constants/* ROUTES.customMobileApp.path */.y2.customMobileApp.path,
                type: "navigation"
            },
            {
                subtitle: "ERP development",
                path: constants/* ROUTES.erpDevelopment.path */.y2.erpDevelopment.path,
                type: "navigation"
            },
            {
                subtitle: "Machine learning development",
                path: constants/* ROUTES.mlDevelopment.path */.y2.mlDevelopment.path,
                type: "navigation"
            },
            {
                subtitle: "AI software development",
                path: constants/* ROUTES.aiDevelopment.path */.y2.aiDevelopment.path,
                type: "navigation"
            },
            {
                subtitle: "Data science development",
                path: constants/* ROUTES.dataScienceDevelopment.path */.y2.dataScienceDevelopment.path,
                type: "navigation"
            },
            {
                subtitle: "Discovery phase",
                path: constants/* ROUTES.discoveryPhase.path */.y2.discoveryPhase.path,
                type: "navigation"
            }, 
        ]
    },
    {
        title: "Services",
        type: "services",
        links: [
            {
                subtitle: "Web development",
                path: constants/* ROUTES.customWebApp.path */.y2.customWebApp.path,
                type: "navigation"
            },
            {
                subtitle: "Mobile development",
                path: constants/* ROUTES.customMobileApp.path */.y2.customMobileApp.path,
                type: "navigation"
            },
            {
                subtitle: "iOS app development",
                path: constants/* ROUTES.iosDevelopmentServices.path */.y2.iosDevelopmentServices.path,
                type: "navigation"
            },
            {
                subtitle: "Android app development",
                path: constants/* ROUTES.androidDevelopmentServices.path */.y2.androidDevelopmentServices.path,
                type: "navigation"
            },
            {
                subtitle: "Cross-platform development",
                path: constants/* ROUTES.crossPlatformDevelopmentServices.path */.y2.crossPlatformDevelopmentServices.path,
                type: "navigation"
            },
            {
                subtitle: "UX/UI design",
                path: constants/* ROUTES.designServices.path */.y2.designServices.path,
                type: "navigation"
            },
            {
                subtitle: "MVP development",
                path: constants/* ROUTES.mvpDevelopment.path */.y2.mvpDevelopment.path,
                type: "navigation"
            },
            {
                subtitle: "DevOps",
                path: constants/* ROUTES.devOpsDevelopment.path */.y2.devOpsDevelopment.path,
                type: "navigation"
            },
            {
                subtitle: "Quality assurance",
                path: constants/* ROUTES.softwareQualityAssuranceServices.path */.y2.softwareQualityAssuranceServices.path,
                type: "navigation"
            },
            {
                subtitle: "Penetration testing",
                path: constants/* ROUTES.penetrationTesting.path */.y2.penetrationTesting.path,
                type: "navigation"
            },
            {
                subtitle: "Cloud development",
                path: constants/* ROUTES.cloudDevelopment.path */.y2.cloudDevelopment.path,
                type: "navigation"
            },
            {
                subtitle: "PWA development",
                path: constants/* ROUTES.pwaDevelopmentServices.path */.y2.pwaDevelopmentServices.path,
                type: "navigation"
            },
            {
                subtitle: "Software prototyping",
                path: constants/* ROUTES.prototypingServices.path */.y2.prototypingServices.path,
                type: "navigation"
            }, 
        ]
    },
    {
        title: "Fintech",
        type: "fintech",
        links: [
            {
                subtitle: "Fintech software development",
                path: constants/* ROUTES.fintechDevelopment.path */.y2.fintechDevelopment.path,
                type: "navigation"
            },
            {
                subtitle: "Trading platform development",
                path: constants/* ROUTES.tradingSoftwareDevelopment.path */.y2.tradingSoftwareDevelopment.path,
                type: "navigation"
            },
            {
                subtitle: "Lending software development",
                path: constants/* ROUTES.lendingSoftwareDevelopment.path */.y2.lendingSoftwareDevelopment.path,
                type: "navigation"
            },
            {
                subtitle: "E-wallet app development",
                path: constants/* ROUTES.eWalletAppDevelopment.path */.y2.eWalletAppDevelopment.path,
                type: "navigation"
            },
            {
                subtitle: "Banking software development",
                path: constants/* ROUTES.bankingSoftwareDevelopmentCompany.path */.y2.bankingSoftwareDevelopmentCompany.path,
                type: "navigation"
            },
            {
                subtitle: "Crowdfunding platform development",
                path: constants/* ROUTES.crowdfundingPlatform.path */.y2.crowdfundingPlatform.path,
                type: "navigation"
            }, 
        ]
    },
    {
        title: "Company",
        type: "company",
        links: [
            {
                subtitle: "Web development",
                path: constants/* ROUTES.customWebApp.path */.y2.customWebApp.path,
                type: "navigation"
            },
            {
                subtitle: "Mobile development",
                path: constants/* ROUTES.customMobileApp.path */.y2.customMobileApp.path,
                type: "navigation"
            },
            {
                subtitle: "iOS app development",
                path: constants/* ROUTES.iosDevelopmentServices.path */.y2.iosDevelopmentServices.path,
                type: "navigation"
            }, 
        ]
    }, 
];
var companyLinks = [
    {
        subtitle: constants/* ROUTES.portfolio.title */.y2.portfolio.title,
        path: constants/* ROUTES.portfolio.path */.y2.portfolio.path,
        type: "navigation"
    },
    {
        subtitle: constants/* ROUTES.process.title */.y2.process.title,
        path: constants/* ROUTES.process.path */.y2.process.path,
        type: "navigation"
    },
    {
        subtitle: constants/* ROUTES.blog.title */.y2.blog.title,
        path: constants/* ROUTES.blog.path */.y2.blog.path,
        type: "navigation"
    }, 
];
var footerImage = "https://images.ctfassets.net/ic8vz4cuikua/2VtLiZQrIUwGOfEdfGfFcT/966edd520f3519cd4a7c6a090d4d483e/image_3.png";

;// CONCATENATED MODULE: ./UI/sections/Footer/DefaultFooter/FooterBody/index.jsx










var FooterCenter = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default())["footer-body"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default())["block-1"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkWrapper/* default */.Z, {
                        path: "/",
                        className: (styles_module_default()).logo,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                type: "whiteLogo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                type: "whiteYellowText"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (styles_module_default())["white-text"],
                        children: "Software innovation powerhouse born to take your business to the top!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClutchWidget/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default())["block-2"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).contentWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default())["block-2__content"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                    path: "mailto:hi@yellow.systems",
                                    className: (styles_module_default())["large-text"],
                                    target: "_blank",
                                    children: "hi@yellow.systems"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (styles_module_default())["large-text"],
                                    children: "+1 (940) 601 6017"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (styles_module_default())["contact-links"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                            className: classnames_default()((styles_module_default())["link-text"], (styles_module_default()).bookButton),
                                            path: "https://calendly.com/yellow-systems-crew/30min",
                                            target: "_blank",
                                            children: "Book a call"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                            className: classnames_default()((styles_module_default())["link-text"], (styles_module_default()).chatButton),
                                            path: "http://wa.me/19406016017",
                                            target: "_blank",
                                            children: "Chat with us"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).contentWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).cityImage,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: (0,helpers/* getContentfulImage */.t)({
                                        src: footerImage,
                                        format: "webp",
                                        width: 400
                                    }),
                                    width: 200,
                                    height: 71,
                                    lazyBoundary: "200px",
                                    unoptimized: true,
                                    loader: function(args) {
                                        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({}, args));
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (styles_module_default())["large-text"],
                                children: "San Francisco, US"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (styles_module_default())["grey-text"],
                                children: "44 Tehama St, CA 94105"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FooterBody = (FooterCenter);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/constants/contacts.js
var contacts = __webpack_require__(32522);
// EXTERNAL MODULE: ./UI/sections/Footer/DefaultFooter/FooterFoot/styles.module.scss
var FooterFoot_styles_module = __webpack_require__(61054);
var FooterFoot_styles_module_default = /*#__PURE__*/__webpack_require__.n(FooterFoot_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Footer/DefaultFooter/FooterFoot/index.jsx






var FooterFoot = function() {
    var pathname = (0,router.useRouter)().pathname;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FooterFoot_styles_module_default())["footer-foot"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FooterFoot_styles_module_default())["social-links"],
                children: Object.values(contacts/* SOCIAL_MEDIA */.CL).map(function(param) {
                    var icon = param.iconLight, title = param.title, link = param.link;
                    return link && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                        className: (FooterFoot_styles_module_default())["social-link"],
                        path: link,
                        googleAnalyticProps: {
                            action: "Click",
                            category: "Social",
                            label: pathname,
                            data: title
                        },
                        isSocialLink: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                            type: icon,
                            className: (FooterFoot_styles_module_default()).icon
                        })
                    }, "networks/".concat(link));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FooterFoot_styles_module_default()).bottom,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\xa9 All right reserved. Yellow 2026"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FooterFoot_styles_module_default())["privacy-policy"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                path: "/privacy-policy",
                                className: (FooterFoot_styles_module_default()).link,
                                children: "Privacy Policy"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                path: "/terms-and-conditions",
                                className: (FooterFoot_styles_module_default()).link,
                                children: "Terms & Privacy"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var DefaultFooter_FooterFoot = (FooterFoot);

// EXTERNAL MODULE: ./UI/sections/Footer/DefaultFooter/CircleButton/styles.module.scss
var CircleButton_styles_module = __webpack_require__(9474);
var CircleButton_styles_module_default = /*#__PURE__*/__webpack_require__.n(CircleButton_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Footer/DefaultFooter/CircleButton/index.jsx



var CircleButton = function() {
    var onClick = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: (CircleButton_styles_module_default()).button,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
            type: "arrowNarrowUp"
        })
    });
};
/* harmony default export */ var DefaultFooter_CircleButton = (CircleButton);

// EXTERNAL MODULE: ./UI/sections/Footer/DefaultFooter/styles.module.scss
var DefaultFooter_styles_module = __webpack_require__(66821);
var DefaultFooter_styles_module_default = /*#__PURE__*/__webpack_require__.n(DefaultFooter_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Footer/DefaultFooter/index.jsx






var DefaultFooter = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (DefaultFooter_styles_module_default()).footerContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultFooter_CircleButton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterBody, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultFooter_FooterFoot, {})
        ]
    });
};
/* harmony default export */ var Footer_DefaultFooter = (DefaultFooter);


/***/ }),

/***/ 32522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ SOCIAL_MEDIA; },
/* harmony export */   "UE": function() { return /* binding */ PHONE_NUMBER; },
/* harmony export */   "Vr": function() { return /* binding */ EMAIL_LINK; },
/* harmony export */   "o4": function() { return /* binding */ ADDRESS; },
/* harmony export */   "zm": function() { return /* binding */ PLACEMENT_DATA; }
/* harmony export */ });

var EMAIL_LINK = "hi@yellow.systems";
var SOCIAL_MEDIA = {
    linkedin: {
        id: "linkedin",
        title: "LinkedIn",
        iconDark: "linkedinFilled",
        iconLight: "linkedinWhite",
        link: "https://www.linkedin.com/company/yellow-systems"
    },
    facebook: {
        id: "facebook",
        title: "Facebook",
        iconDark: "facebookDark",
        iconLight: "facebookWhite",
        link: "https://www.facebook.com/yellow.systems/"
    },
    twitter: {
        id: "twitter",
        title: "Twitter",
        iconDark: "twitterFilled",
        iconLight: "twitterWhite",
        link: "https://mobile.twitter.com/yellow_systems"
    },
    dribbble: {
        id: "dribbble",
        title: "Dribbble",
        iconDark: "dribbbleFilled",
        iconLight: "dribbbleWhite",
        link: "https://dribbble.com/yellow_systems"
    },
    behance: {
        id: "behance",
        title: "Behance",
        iconDark: "behanceFilled",
        iconLight: "behanceWhite",
        link: "https://www.behance.net/yellow_systems"
    },
    youtube: {
        id: "youtube",
        title: "YouTube",
        iconDark: "youtubeSocialFilled",
        iconLight: "youtubeWhite",
        link: "https://www.youtube.com/@yellowsystems9900"
    },
    instagram: {
        id: "instagram",
        title: "Instagram",
        iconDark: "instagramFilled",
        iconLight: "instagramWhite",
        link: "https://www.instagram.com/yellow.systems/"
    }
};
var PHONE_NUMBER = {
    us: "+1 (940) 601 6017"
};
var ADDRESS = {
    us: {
        addressCountry: "USA",
        addressLocality: "San Francisco",
        streetAddress: "44 Tehama St",
        postalCode: "94105"
    },
    ar: {
        addressCountry: "Argentina",
        addressLocality: "Buenos Aires",
        streetAddress: "Av. Corrientes 1312",
        postalCode: "C1043ABN"
    },
    pl: {
        addressCountry: "Poland",
        addressLocality: "Warszawa",
        streetAddress: "Grzybowska 62",
        postalCode: "00-855"
    },
    cy: {
        addressCountry: "Cyprus",
        addressLocality: "Larnaca",
        streetAddress: "Agias Faneromenis, 143, Flat 201",
        postalCode: "6031"
    }
};
var PLACEMENT_DATA = {
    USA: [
        "".concat(ADDRESS.us.streetAddress, " ").concat(ADDRESS.us.addressLocality, " ").concat(ADDRESS.us.postalCode), 
    ],
    Poland: [
        "".concat(ADDRESS.pl.addressLocality, " ").concat(ADDRESS.pl.postalCode),
        ADDRESS.pl.streetAddress, 
    ],
    Argentina: [
        "".concat(ADDRESS.ar.streetAddress, " ").concat(ADDRESS.ar.postalCode),
        ADDRESS.ar.addressLocality, 
    ]
};


/***/ }),

/***/ 9474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__EOCWR"};

/***/ }),

/***/ 60547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer-body":"styles_footer-body__v5h8Y","white-text":"styles_white-text__ndaTT","grey-text":"styles_grey-text__BqpN3","large-text":"styles_large-text__KJUkg","contact-links":"styles_contact-links__lM5B4","block-1":"styles_block-1__QUFKt","logo":"styles_logo__mVl_t","clutch-review":"styles_clutch-review__eBigy","block-2":"styles_block-2__Cleh4","block-2__content":"styles_block-2__content__CysoQ","contentWrapper":"styles_contentWrapper__LYXH8","bookButton":"styles_bookButton__f9EvQ","chatButton":"styles_chatButton__BaXeM","cityImage":"styles_cityImage__Fqugm"};

/***/ }),

/***/ 61054:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer-foot":"styles_footer-foot__I7mol","social-links":"styles_social-links__FR253","social-link":"styles_social-link__4Eal9","bottom":"styles_bottom__VKZNA","privacy-policy":"styles_privacy-policy__XTf7m","link":"styles_link__hXUH0"};

/***/ }),

/***/ 66821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"styles_footerContainer__fOuRv"};

/***/ })

}]);